<template>
    <div class="p-5">
        <div v-if="cadhConfig.options && cadhConfig.options.length === 0 && options && options.length === 0"
             class="text-center d-flex flex-column">
            <div>
                <button class="text-center cadh-add-button" @click="openCreateModal()">
                    <span class="font-weight-bold h4">
                        + <br>
                        Ajouter une <br>
                        option
                    </span>
                </button>
            </div>

            <div class="mt-2">
                <a href="https://www.loom.com/share/c975126c7fc84ecfb9a3a2d05e4a097c" target="_blank">
                    C'est quoi ?
                    <v-icon color="primary">open_in_new</v-icon>
                </a>
            </div>
        </div>

        <div v-else>
            <div class="d-flex justify-content-end mb-4">
                <v-btn class="text-none default-button mr-4" @click="openCreateModal()">
                    <v-icon class="mr-1" color="white" dense>
                        add
                    </v-icon>
                    Ajouter une option
                </v-btn>

                <v-btn class="text-none default-button mr-4" @click="setLevelModal(true)">
                    Rubriques
                </v-btn>

                <v-menu end transition="slide-y-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="text-none default-button" v-on="on" :disabled="!selectedOptions.length">
                            Sur la sélection
                            <v-icon>arrow_drop_down</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item @click="deleteMultipleOptions" :disabled="usedInCampaign">
                            <v-list-item-title>
                                <v-icon class="custom-button-error">delete</v-icon>
                                Supprimer les ({{ selectedOptions.length }}) options
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>

            <div>
                <filters></filters>
            </div>

            <v-simple-table class="mt-5">
                <thead>
                <tr>
                    <th class="text-left border-0" width="25px"></th>
                    <th class="text-left" width="40px">
                        <v-checkbox style="padding-top: 0 !important;"
                                    class="p-0 m-0"
                                    v-model="selectAll"
                                    @change="toggleSelectAll"
                                    hide-details>
                        </v-checkbox>
                    </th>
                    <th class="text-left">Nom</th>
                    <th class="text-left">Rubrique</th>
                    <th class="text-left">Réservable</th>
                    <th class="text-left">Prix</th>
                    <th class="text-left">Statut</th>
                    <th class="text-right">Actions</th>
                </tr>
                </thead>
                <draggable v-model="filteredOptions"
                           tag="tbody"
                           handle=".drag-handle"
                           :scroll-sensitivity="200"
                           :force-fallback="true"
                           :options="{
                                animation: 200,
                                ghostClass: 'sortable-ghost',
                                chosenClass: 'sortable-chosen'
                           }"
                           @start="setCopyOptions"
                           @end="onDragEnd"
                           @change="reorderOptions">
                    <tr v-for="option in filteredOptions">
                        <td class="border-0">
                            <v-icon class="drag-handle page__grab-icon" color="gray">mdi-drag</v-icon>
                        </td>
                        <td>
                            <v-checkbox style="padding-top: 0 !important;"
                                        class="p-0 m-0"
                                        v-model="option.selected"
                                        @change="updateSelectAllState"
                                        hide-details>
                            </v-checkbox>
                        </td>
                        <td>
                            <button @click="openUpdateModal(option)" class="text-primary text-start">
                                {{ option.name }}
                            </button>
                        </td>
                        <td>
                            <div v-if="option.level">
                                <v-chip>{{ option.level.name }}</v-chip>
                            </div>
                        </td>
                        <td>{{ option.immediate ? "Non" : "Oui" }}</td>
                        <td>
                            <div v-if="option.price">
                                {{ option.price }} €
                            </div>
                        </td>
                        <td>{{ option.enabled ? "Active" : "Masquée" }}</td>
                        <td class="text-right">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn small icon v-on="on" color="primary" class="custom-button-error"
                                           @click="openUpdateModal(option)">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </template>
                                <span>Modifier</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="ml-3 mr-3" small icon v-on="on" @click="duplicateOption(option)">
                                        <v-icon>content_copy</v-icon>
                                    </v-btn>
                                </template>
                                <span>Dupliquer</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <button v-on="on" class="cadh-config-button-icon"
                                            @click="deleteOption(option.id)"
                                            v-if="!usedInCampaign">
                                        <v-icon color="error">delete</v-icon>
                                    </button>
                                </template>
                                <span>Supprimer</span>
                            </v-tooltip>
                        </td>
                    </tr>
                </draggable>
            </v-simple-table>
        </div>

        <v-dialog ref="dialog" v-model="optionModal" width="900px" persistent>
            <create-option-modal
              :option="selectedOption"
              :mode="modalMode"
            ></create-option-modal>
        </v-dialog>

        <v-dialog ref="dialog" v-model="levelModal" width="900px" persistent>
            <level-modal></level-modal>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import CreateOptionModal from "./CreateOptionModal.vue"
import Confirm from "../../tools/Confirm.vue"
import Filters from "./Filters.vue"
import LevelModal from "./LevelModal.vue"
import draggable from "vuedraggable"
import draggableMixin from "@/mixins/draggableMixin"

export default {
    name: "CadhConfigOptions",
    components: { CreateOptionModal, Confirm, Filters, LevelModal, draggable },
    mixins: [draggableMixin],
    data() {
        return {
            selectedOption: {},
            modalMode: null,
            selectAll: false,
            filteredOptions: [],
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setOptionModal", "setLevelModal", "setModalCurrentStep", "setConfigOptions"]),
        openUpdateModal(option) {
            this.selectedOption = JSON.parse(JSON.stringify(option))
            this.modalMode = "update"
            this.setModalCurrentStep("1")
            this.setOptionModal(true)
        },
        openCreateModal() {
            this.selectedOption = {
                "name": "",
                "label": "",
                "description": "",
                "price": null,
                "level": null,
                "immediate": true,
                "multiple": false,
                "order": this.cadhConfig.options.length + 1,
                "enabled": true,
                "criterias": [],
            }
            this.modalMode = "create"
            this.setModalCurrentStep("1")
            this.setOptionModal(true)
        },
        toggleSelectAll() {
            this.filteredOptions.forEach(item => {
                item.selected = this.selectAll
            })
        },
        deleteOption(id) {
            this.$refs.confirm.open("Attention", "Voulez-vous vraiment supprimer cette option ?",
              { color: "red" }).then((confirm) => {
                if (confirm) {
                    this.$store.dispatch("cadhConfig/deleteOption", id)
                }
            })
        },
        deleteMultipleOptions() {
            this.$refs.confirm.open("Attention", "Voulez-vous vraiment supprimer les options sélectionnées ?",
              { color: "red" }).then((confirm) => {
                if (confirm) {
                    let payload = {
                        "ids": this.selectedOptions.map(option => option.id),
                    }

                    this.$store.dispatch("cadhConfig/deleteOptions", payload)
                }
            })
        },
        duplicateOption(option) {
            this.selectedOption = JSON.parse(JSON.stringify(option))
            this.selectedOption.order = this.cadhConfig.options.length + 1
            this.modalMode = "create"
            this.setModalCurrentStep("1")
            this.setOptionModal(true)
        },
        setCopyOptions(event) {
            this.copyOptions = JSON.parse(JSON.stringify(this.options))

            this.onDragStart(event)
        },
        reorderOptions(event) {
            if (event.moved) {
                const pointerType = event.moved.newIndex !== this.options.length - 1 ? "before" : "after"
                const moveObject = event.moved.element.id
                const pointerId = this.copyOptions[event.moved.newIndex].id

                this.$store.dispatch("cadhConfig/reorderList", [
                    "cadh_options",
                    this.cadhConfig.id,
                    pointerId,
                    pointerType,
                    moveObject,
                ]).then(res => {
                    this.options = res.body.data.items
                })
            }
        },
        updateSelectAllState() {
            const allSelected = this.options.every(item => item.selected)
            this.selectAll = allSelected
        },
        filerByQuestions() {
            return this.options.filter(data => {
                return this.checkIfDataHasCriterias(data)
            })
        },
        checkIfDataHasCriterias(data) {
            let hasCriteria = false
            let criteriasIds = data.criterias.map(criteria => criteria.id)
            let newArray = []
            let resultsArray = []

            this.criteriaFamilies.forEach(family => {
                newArray[family.id] = family.criterias.filter(criteria => {
                    return this.criteriasFilter.includes(criteria.id)
                })
            })

            newArray.forEach(array => {
                if(array.length > 0) {
                    hasCriteria = array.map(obj => obj.id).some(value => criteriasIds.includes(value))
                    resultsArray.push(hasCriteria)
                }
            })

            return resultsArray.every((value) => value === true)
        },
        filterByName() {
            return this.options.filter(type => {
                return type.name.toLowerCase().includes(this.searchName)
            })

        },
        filerByNameAndCriterias() {
            return this.options.filter(type => {
                return type.name.toLowerCase().includes(this.searchName) && this.checkIfDataHasCriterias(type)
            })
        },
        setFilteredData(datas = null) {
            if (datas === null) {
                datas = this.options
            }

            this.filteredOptions = datas
        },
        useRightFilter() {
            if ((this.searchName === "" || this.searchName === null) && this.criteriasFilter.length === 0) {
                this.setFilteredData()
            } else if ((this.searchName === "" || this.searchName === null) && this.criteriasFilter.length > 0) {
                this.setFilteredData(this.filerByQuestions())
            } else if (this.criteriasFilter.length === 0 && this.searchName !== "" && this.searchName !== null) {
                this.setFilteredData(this.filterByName())
            } else {
                this.setFilteredData(this.filerByNameAndCriterias())
            }
        },
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "optionModal", "configOptions", "levelModal", "searchName",
            "criteriasFilter", "usedInCampaign", "criteriaFamilies"]),
        options: {
            get() {
                return this.configOptions
            },
            set(value) {
                this.$store.commit("cadhConfig/setConfigOptions", value)
            },
        },
        selectedOptions() {
            return this.filteredOptions.filter(option => option.selected)
        },
    },
    watch: {
        searchName() {
            this.useRightFilter()
        },
        criteriasFilter() {
            this.useRightFilter()
        },
        options() {
            if ((this.searchName === "" || this.searchName === null) && this.criteriasFilter.length === 0) {
                this.filteredOptions = this.options
            } else if ((this.searchName === "" || this.searchName === null) && this.criteriasFilter.length > 0) {
                this.filteredOptions = this.filerByQuestions()
            } else if (this.criteriasFilter.length === 0 && this.searchName !== "" && this.searchName !== null) {
                this.filteredOptions = this.filterByName()
            } else {
                this.filteredOptions = this.filerByNameAndCriterias()
            }
        },
    },
}
</script>